export default{
    messageType : {
        SUCCESS: 'success',
        ERROR: 'error',
        WARNING: 'warning'
    },
    dispatch: {
        SET_USER_INFORMATION_TO_STORE: 'setUserInformationToStore',
        SET_USER_FOLLOWINGS_TO_STORE: 'setUserFollowingsToStore'

    },
    getters: {
        GET_USER_INFORMATION: 'getUserInformation',
        GET_USER_FOLLOWINGS: 'getUserFollowings',
        GET_ORGANSIATION_WITHOUT_COLLABORATOR: 'getOrganisationWithoutCollaborator',
        GET_SELECTED_ACCOUNT: 'getSelectedAccount'
    },
    actions: {
        SET_USER_FOLLOWINGS: 'SET_USER_FOLLOWINGS'
    },
    support:{
        SUPPORT_EMAIL: 'ass@accura.atlassian.net',
        KNOWLEDGE_BASE: 'https://accura.atlassian.net/servicedesk/customer/portals',
        LEARNING_CENTER: 'https://lc.accura.onl'
    },
    AUTHOR: {
        key: 'AUTHOR',
        value: 'Author',
        route: 'Authors',
        filter: 'author'
    },
    PUBLISHER: {
        key: 'PUBLISHER',
        value: 'Publisher',
        route: 'Publishers',
        filter: 'publisher'
    },
    PUBLICATION: {
        key: 'PUBLICATION',
        value: 'Publication',
        route: 'Publications',
        filter: 'publication'
    },
    ARTICLE: {
        key: 'ARTICLE',
        value: 'Content',
        route: 'Articles',
        filter: 'content'
    },
    DASHBOARDUSER: {
        key: 'USER',
        value: 'Content',
        route: 'users',
        filter: 'content'
    },
    USER: {
        route: 'Users',
        filter: 'user'
    },
    ADMIN: {
        Articles: {
            key: 'Articles',
            value: 'contents',
            value_without_s: 'ARTICLE'
        },
        Authors: {
            key: 'Authors',
            value: 'authors',
            value_without_s: 'AUTHOR'
        },
        Publications: {
            key: 'Publications',
            value: 'publications',
            value_without_s: 'PUBLICATION'
        },
        Publishers: {
            key: 'Publishers',
            value: 'publishers',
            value_without_s: 'PUBLISHER'
        },
        Users: {
            key: 'Users',
            value: 'users',
            value_without_s: 'USER'
        },
        Members: {
            key: 'Users',
            value: 'users',
            value_without_s: 'USER'
        },
        ALL: {
            key: 'all',
            value_without_s: 'ALL'
        },
        Organisations: {
            Key: 'Organisations',
            value_without_s: 'ORGANISATION'
        }
    },
    ROLE: {
        ADMIN: 'ad_1024'
    },
    ACTION:{
        Add: 'ADD',
        Remove: 'REMOVE',
        ReplaceWith: 'REPLACE_WITH'
    },
    PUBLISHER_TABS: {
        CONTENT_DB: 'Content DB',
        SETTINGS: 'Settings',
        PUBLICATIONS: 'Publications',
        AUTHORS: 'Authors',
        PUBLISHER: 'Publisher',
        SUBSCRIBER_DB: 'Subscriber DB',
        ARTICLES: 'Articles',
    },
    GET_DATA: {
        USER: {
            value: '',
            routeName: 'subscriptions',
            EDIT: 'editUsers'
        },
        AUTHOR: {
            value: 'authors',
            routeName: 'info-authors',
            EDIT: 'editAuthors'
        },
        PUBLISHER: {
            value: 'publishers',
            routeName: 'info-publishers',
            EDIT: 'editPublishers'
        },
        PUBLICATION: {
            value: 'publications',
            routeName: 'info-publications',
            EDIT: 'editPublications'
        },
        ARTICLE: {
            value: 'contents',
            routeName: 'info-articles',
            EDIT: 'editArticles'
        }
    },
    REPLACE_META: {
        REPLACE_WITH: {
            value: 'Replace with',
            key: 'REPLACE_WITH'
        },
        REPLACE_WITH_DELETE: {
            value: 'Replace with and',
            key: 'REPLACE_WITH_DELETE'
        }
    },
    ACCOUNT_TYPE: {
        TWITTER: {
            key: 'TWITTER',
            value: 'twitter'
        },
        FACEBOOK: {
            key: 'FACEBOOK',
            value: 'facebook'
        }
    },
    TWITTER_OPTIONS: {
        SHARE_TO_TIMELINE: 'Share to timeline',
        TIMELINE: {
          value: 'TIMELINE',
          label: 'Timeline'
        },
        OTHERS: {
          value: 'OTHER',
          label: 'Others'
        }
    },
    LIST: {
        REGULAR_COLLECTION: 'REGULAR_COLLECTION',
        DOSSIER: 'DOSSIER',
        COLLECTION: 'COLLECTION',
        COLLECTION_ARTICLES: 'COLLECTION_ARTICLES',
        FOLLOWERS: 'followers',
        FOLLOWING: 'following' 
    },
    PLATFORMS: {
        TWITTER: 'TWITTER',
        FACEBOOK: 'FACEBOOK',
        REDDIT: 'REDDIT',
        SLACK: 'SLACK',
        FLIPBOARD: 'FLIPBOARD',
        LINKEDIN: 'LINKEDIN',
        EMAIL: 'EMAIL',
        PARLER: 'PARLER',
    },
    ORGANISATIONS: {
        ORGANISATION: 'ORGANISATION',
        TEAM: 'TEAM'
    },
    PEOPLE_LIST: {
        PENDING_INVITATION: 'PENDING_INVITATION',
        INVITE_MEMBER: 'INVITE_MEMBER',
        FAILED_INVITATION: 'FAILED_INVITATION',
        PENDING_COLLABORATORS: 'PENDING_COLLABORATORS',
        MEMBER: 'MEMBER',
        PEOPLE: 'PEOPLE'
    },
    ORGANISATION_RIGHTS: {
        OWNER: 'OWNER',
        MEMBER: 'MEMBER'
    },
    DONATION_TIERS: {
        MONTHLY_TIER: 'monthly_tier',
        ONE_TIME_TIER: 'one_time_tier'
    },
    DONATION_CURRENCY: {
        EURO: 'EURO',
        DOLLAR: 'DOLLAR',
        DOLLAR_SIGN: '$',
        EURO_SIGN: '€'
    }
}
